/**
 * RFC #323: shared definition of "pseudo-provider" keys — values that
 * appear on action pills (`ai.reason`, `notify.email`, browser steps,
 * tool-namespace pills) but don't map to a connectable IntegrationType.
 *
 * Components that need to gate on "is this pill targeting a real
 * integration?" must use this list rather than maintaining their own
 * copies — the lists used to drift (one excluded `'runbook'`, the other
 * excluded `'browser'`) and that's a real bug surface.
 */

/** Lowercase pill provider keys that don't bind to an IntegrationType. */
export const PSEUDO_ACTION_PROVIDERS = new Set<string>([
  'ai',
  'notify',
  'browser',
  'tool',
  'runbook',
])

/**
 * True when the pill targets a real integration provider that the user
 * could pick a connection for (AWS, GitHub, Okta, …). False for AI /
 * notify / browser / tool / runbook pseudo-providers and for tool-style
 * pills (`tool` set) regardless of provider.
 */
export function isNativeIntegrationProvider(input: {
  provider: string | undefined
  tool?: string | undefined
}): boolean {
  if (input.tool && input.tool.trim().length > 0) return false
  const provider = (input.provider ?? '').trim().toLowerCase()
  if (provider.length === 0) return false
  return !PSEUDO_ACTION_PROVIDERS.has(provider)
}
